<template>
  <section>
    <FullModal :headerInfo="headerInfo" @onClose="onCloseMap">
      <template #content>
        <div id="legend">
          <div
            class="flex flex-row flex-wrap border-2 border-[#CDE3F4] w-full min-h-[50px] rounded-md min-w-[350px] gap-8 px-8 py-2"
          >
            <div
              class="flex items-center gap-2"
              v-for="(item, i) in legends"
              :key="i"
            >
              <img :src="item.icon" alt="icon" />
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>

        <div id="graphs">
          <LearningMap
            :userId="user.id"
            :courseId="idCourse"
            :type="'STUDENT_LEARNING_MAP'"
          />
        </div>
      </template>
    </FullModal>
  </section>
</template>

<script lang="ts">
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent } from "vue";
import { LearningMapService } from "../learning-map.service";

export default defineComponent({
  name: "courseLearningMapStudent",
  emits: ["onCloseMap"],
  computed: {
    service(): LearningMapService {
      return new LearningMapService();
    },
    idCourse(): any {
      return this.$route.params.id;
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      legends: [
        {
          icon: require("@/assets/images/learning-map/student-cap.svg"),
          name: "Capítulo",
          nameEn: "Chapter",
        },
        {
          icon: require("@/assets/images/learning-map/student-objective.svg"),
          name: "Objetivo de aprendizagem",
          nameEn: "Learning Objective",
        },
        {
          icon: require("@/assets/images/learning-map/student-object-default.svg"),
          name: "Acessar material",
          nameEn: "Access material",
        },
      ],
      headerInfo: {
        title: this.$t("labels.generic", {
          pt: "Mapa de conteúdos",
          en: "Contents Map",
        }),
        subtitle: this.$t("labels.generic", {
          pt: "Clique nos conteúdos e acesse os itens que você já viu no curso",
          en: "Click on the contents and access the items you have already seen in the course.",
        }),
        icon: "course-student/icon-card.svg",
      } as any,
    };
  },
  methods: {
    onCloseMap(): void {
      this.$emit("onCloseMap");
    },
  },
});
</script>
